module.exports = __webpack_public_path__ + "img/Noroeste.cb0a811f.svg";